import { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { getDwellTimeTracker } from './getDwellTimeTracker';

export const useDwellTime = (eventData, iframeDwell?: boolean) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	useEffect(() => {
		if (eventData) {
			void getDwellTimeTracker(iframeDwell).then((tracker) => {
				void tracker.startAny(eventData, (callbackData) => {
					createAnalyticsEvent({
						type: 'sendTrackEvent',
						data: callbackData,
					}).fire();
				});
			});
			return () => {
				void getDwellTimeTracker(iframeDwell).then((tracker) => {
					tracker.stop();
				});
			};
		}
		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [createAnalyticsEvent, JSON.stringify(eventData)]);
};
